import React, { useMemo } from 'react';
import { pick } from 'ramda';
import { Loader } from 'js/components/common/Loader';
import { ManagedPopup } from 'js/components/common/Popup';
import { useSanitize } from 'js/hooks/useSanitize';
import { WebContentInner } from 'js/components/system/WebContent';
import { useResizeLayout } from 'js/components/common/PopupManager/hooks';

import * as hooks from './hooks';

import style from './AdvancedPlayerMessage.scss';

const popupClassNames = pick(['actionButtons', 'header'], style);

export const AdvancedPlayerMessage = ({ data, refs, isActive, ...props }) => {
    useResizeLayout(refs);

    const { message, imageUrl } = data.action;
    const safeMessage = useSanitize(message);
    const imageInfo = hooks.useLoadImage(data);
    const getButtons = hooks.useGetButtons();
    const { buttons, onClose } = useMemo(() => {
        return getButtons({
            buttons: data.action.buttons,
            actionId: data.actionId,
            windowSessionId: data.windowSessionId
        });
    }, [data, getButtons]);
    const { className, inlineStyle } = hooks.useStyleAttributes({ imageInfo, imageUrl });

    if (isActive && imageUrl && !imageInfo) {
        return <Loader className={style.loader} />;
    }

    return (
        <ManagedPopup
            {...props}
            className={className}
            classNames={popupClassNames}
            onClose={onClose}
            style={inlineStyle}
            buttons={buttons}
        >
            <WebContentInner
                content={safeMessage}
                className={style.htmlContainer}
                context={`advancedPlayerMessage::${data.actionId}`}
            />
        </ManagedPopup>
    );
};
